import React from 'react';
import { Card, Col, ColProps } from 'react-bootstrap';

import { QuotePremiumCardBody } from '@components/Feature/Quote';
import { CorporateHealthQuote } from '@models/CorporateHealthQuote';

type Props = Pick<ColProps, 'children'> & {
  corporateHealthQuote: CorporateHealthQuote
};

const RightCol = ({ children, corporateHealthQuote }: Props) => {
  if (!corporateHealthQuote) return null;

  return (
    <Col lg>
      <Card className="mb-4">
        <QuotePremiumCardBody {...corporateHealthQuote} planName={corporateHealthQuote.healthPlanName} />
        {children}
      </Card>
    </Col>
  );
};

export { RightCol };
